import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './app/App';
import reportWebVitals from './reportWebVitals';
import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import Configuration  from './config/einvoicing-configuration';

// Accessibility: load axe-core in development to surface a11y violations in the browser console
if (process.env.NODE_ENV === 'development') {
  Promise.all([import('@axe-core/react'), import('react-dom')])
    .then(([axe, reactDOM]) => {
      axe.default(React, reactDOM, 1000);
    })
    .catch(() => {});
}



const msalInstance = new PublicClientApplication(Configuration.msalConfig); //replace with msalDevConfig to run local

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <MsalProvider instance={msalInstance}>
      <App />
    </MsalProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
